<div class="more-details-container">
  <div class="person-info" [formGroup]="moreInfoForm.get('person')">
    <p class="title">Pessoal</p>
    <div class="inputs-line">
      <div class="person-input">
        <p class="input-title">RG</p>
        <div class="rg-input">
          <input id="rg-input" type="text" maxlength="12"  formControlName="rg" placeholder="00 000 000 0" (keypress)="formatRG($event)">
        </div>
      </div>
      <div class="person-input">
        <p class="input-title">CPF</p>
        <nav-input-login class="lib-input" formControlName="cpf" [inputId]="'cpf-input'" [placeholder]="'000 000 000 00'" [invalid]="moreInfoForm.get('person').get('cpf').invalid && saved" [maskInput]="'000 000 000 00'"></nav-input-login>
        <div class="error-msg" *ngIf="moreInfoForm.get('person').get('cpf').invalid && saved">
          <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
          <span>Digite um CPF válido</span>
        </div>     
      </div>
      <div class="person-input">
        <p class="input-title">Profissão</p>
        <nav-input-login [inputId]="'occupation-input'" class="lib-input" formControlName="occupation" [placeholder]="'Ex.: vendedor'"></nav-input-login>
      </div>
    </div>
    <div class="inputs-line">
      <div class="person-input">
        <p class="input-title">Cônjuge</p>
        <nav-input-login [inputId]="'spouse-input'" class="lib-input" formControlName="spouse" [placeholder]="'Nome completo'"></nav-input-login>
      </div>
      <div class="person-input">
        <p class="input-title">Data de nascimento</p>
        <lib-datepicker id="birth-date-picker" class="datepicker-input" [ngClass]="{error: moreInfoForm.get('person').get('birth_date').invalid && saved}" (dateChange)="moreInfoForm.get('person').get('birth_date').patchValue($event)" format='dd/MM/yyyy' 
        [date]="moreInfoForm.get('person').get('birth_date').value" [allowPastDate]="true" [allowFutureDate]="false"></lib-datepicker>
        <div class="error-msg" *ngIf="moreInfoForm.get('person').get('birth_date').invalid && saved">
          <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
          <span>A idade deve ser superior a 12 anos</span>
        </div> 
      </div>
    </div>
  </div>

  <div class="address-info" [formGroup]="moreInfoForm.get('address')">
    <p class="title">Informações de endereço</p>
    <div class="address-zip_code-input">
      <p class="input-title">Cep</p>
      <app-zip-code-flag-input formControlName="zip_code" [placeholder]="'00000-000'" [invalid]="moreInfoForm.get('address').get('zip_code').invalid && saved" (input)="getAddress()" (changeFlagValue)="currentFlag = $event"></app-zip-code-flag-input>
      <div class="error-msg" *ngIf="moreInfoForm.get('address').get('zip_code').invalid && saved">
        <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
        <span>Cep inválido</span>
      </div> 
    </div>
    <div class="address-line">
      <div class="address-input">
        <p class="input-title">Endereço</p>
        <nav-input-login [inputId]="'street-input'" class="lib-input" formControlName="street" [placeholder]="'Rua, alameda, avenida, etc'" [invalid]="moreInfoForm.get('address').get('street').invalid && saved"></nav-input-login>
        <div class="error-msg" *ngIf="moreInfoForm.get('address').get('street').invalid && saved">
          <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
          <span>Digite o endereço</span>
        </div> 
      </div>
      <div class="address-line neighborhood">
        <div class="number-input">
          <p class="input-title">Número</p>
          <nav-input-login [inputId]="'number-input'" class="lib-input" formControlName="number" [placeholder]="'Ex.: 10'" [maskInput]="'0{10}'"></nav-input-login>
        </div>
        <div class="neighborhood-input">
          <p class="input-title">Bairro</p>
          <nav-input-login [inputId]="'neighborhood-input'" class="lib-input" formControlName="neighborhood" [placeholder]="'Ex.: Centro'" [invalid]="moreInfoForm.get('address').get('neighborhood').invalid && saved"></nav-input-login>
          <div class="error-msg" *ngIf="moreInfoForm.get('address').get('neighborhood').invalid && saved">
            <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
            <span>Digite o bairro</span>
          </div> 
        </div>
      </div>  
    </div>
    <div class="address-line last-line">
      <div class="address-input-generic">
        <p class="input-title">Complemento</p>
        <nav-input-login [inputId]="'complement-input'" class="lib-input" formControlName="complement" ></nav-input-login>
      </div>
      <div class="address-input-generic">
        <p class="input-title">Cidade</p>
        <nav-input-login [inputId]="'city-input'" class="lib-input" formControlName="city" [placeholder]="'Ex.: São Paulo'" [invalid]="false" [disabled]="true"></nav-input-login>
      </div>
      <div class="address-input-generic">
        <p class="input-title">Estado</p>
        <nav-input-login [inputId]="'state-input'" class="lib-input" formControlName="state" [placeholder]="'Ex.: São Paulo'" [invalid]="false" [disabled]="true"></nav-input-login>
      </div>
    </div>
  </div>
  <div class="btn-container">
    <lib-button-primary (click)="saveMoreInfo()">Salvar</lib-button-primary>
  </div>
</div>